/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';

import { FAILURE, REQUEST, SUCCESS } from '../../actions/utils';

import { ICommonResponse, IDictionaryItem } from '../../api/types';

import genericReducers from '../genericReducer';
import { GET_ACTION_KINDS } from '../../actions';

import { IReducers } from '..';

export type ActionKindsState = ICommonResponse<IDictionaryItem>;

const initialState = {} as ICommonResponse<IDictionaryItem>;
const generic = genericReducers<ActionKindsState>();
const actionKinds: IReducers<ActionKindsState> = {
  [GET_ACTION_KINDS[REQUEST]]: generic.get.request,
  [GET_ACTION_KINDS[SUCCESS]]: generic.get.success,
  [GET_ACTION_KINDS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, actionKinds);
